// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"appWrapper_menuBar__2JyzT","iconButton":"appWrapper_iconButton__oPwyB","iconButtonIcon":"appWrapper_iconButtonIcon__g_OoK"};